export default __webpack_public_path__ + "app/images/user/img-ai-customer-service-01.png";